import {SpringPageable} from "@variocube/app-ui";

export const queryKeys = {
	// Booking Shares
	bookingShare: (
		tenantId: string,
		bookingId: number,
		bookingShareId: number,
	) => ["bookingShare", tenantId, bookingId, bookingShareId],

	bookingShares: {
		all: () => ["bookingShares"] as const,
		byBooking: (tenantId: string, bookingId: number) => ["bookingShares", tenantId, bookingId] as const,
		list: (tenantId: string, bookingId: number, query: {
			sort?: string[];
			size?: number;
			page?: number;
			status?: "ACTIVE" | "EXPIRED";
		}) => ["bookingShares", tenantId, bookingId, query] as const,
		count: (tenantId: string, bookingId: number) => ["bookingShareCount", tenantId, bookingId] as const,
	},

	// Statistics
	locationTrees: (tenantId: string) => ["locationTrees", tenantId],
	utilizationStatistics: (
		tenantId: string,
		locationId: number | undefined | null,
		from: string | undefined | null,
		until: string | undefined | null,
	) => ["utilizationStatistics", tenantId, locationId, from, until],
	bookingsWhichHaveBeenClosedButNotOpenedList: (
		tenantId: string,
		from: string | undefined | null,
		until: string | undefined | null,
		pageable: SpringPageable,
	) => ["bookingsWhichHaveBeenClosedButNotOpenedList", tenantId, from, until, pageable],
	bookingsWhichHaveBeenNeitherOpenedNorClosedList: (
		tenantId: string,
		from: string | undefined | null,
		until: string | undefined | null,
		pageable: SpringPageable,
	) => ["bookingsWhichHaveBeenNeitherOpenedNorClosedList", tenantId, from, until, pageable],
	compartmentsWithoutUsage: (
		tenantId: string,
		from: string | undefined | null,
		until: string | undefined | null,
		pageable: SpringPageable,
	) => ["compartmentsWithoutUsage", tenantId, from, until, pageable],

	// Bulk Booking Operations
	bulkBookingOperations: (tenantId: string) => ["bulkBookingOperations", tenantId] as const,

	// Users
	tenantUser: (tenantId: string, username: string) => ["tenantUser", tenantId, username] as const,

	// Compartments
	compartment: (tenantId: string, compartmentId: number) => ["compartment", tenantId, compartmentId] as const,
	activeCompartmentBooking: (tenantId: string, compartmentId: number) =>
		["activeCompartmentBooking", tenantId, compartmentId] as const,
	compartmentBookings: (tenantId: string, compartmentId: number, pageable: SpringPageable) =>
		["compartmentBookings", tenantId, compartmentId, pageable] as const,

	// Subscriptions
	subscriptions: {
		all: () => ["subscriptions"] as const,
		list: (query: object) => ["subscriptions", query] as const,
	},
	tenantSubscriptions: (tenantId: string) => ["tenantSubscriptions", tenantId] as const,
	tenants: (query: object) => ["tenants", query] as const,
	plans: (query: object) => ["plans", query] as const,
};
